import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { MailboxProviderId } from 'fym-shared/src/music24/outreach/mailboxProviders';
import { TypedMemo } from '../../../common/types';
import { MAILBOX_GUIDE_COPY } from './mailboxGuideCopy';
import { mailboxGuideMessages as messages } from './mailboxGuideMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the guide; each part uses its own slice of it */
import styles from './MailboxGuide.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface GuideHelpProps {
  providerId: MailboxProviderId;
  onAdmin: () => void;
}

/** The help lines of a provider (design outreach-v2 o2 "I do not see App passwords"). */
const GuideHelpComponent: React.FC<GuideHelpProps> = ({ providerId, onAdmin }) => {
  const intl = useIntl();
  const lines = useMemo(
    () => MAILBOX_GUIDE_COPY[providerId].help.map((line) => <span key={line.id}>• {intl.formatMessage(line)}</span>),
    [intl, providerId]
  );
  if (lines.length === 0) {
    return null;
  }
  return (
    <div className={styles.help} data-testid="guide-help">
      <b>{intl.formatMessage(providerId === 'gmail' ? messages.helpTitleGmail : messages.helpTitle)}</b>
      {lines}
      {providerId === 'gmail' && (
        <button type="button" className="btn btn-link btn-sm p-0 text-start" onClick={onAdmin}>
          {intl.formatMessage(messages.adminLink)}
        </button>
      )}
    </div>
  );
};

export const GuideHelp = TypedMemo(GuideHelpComponent);
